import type { ComponentProps } from 'react';
import { Modal as Modals } from '@/components/common/display/modal/v3';
import image from './adac-home-protection.jpg';
import imageWebp from './adac-home-protection.webp';

const { V3: Modal } = Modals;

export const AdacBanner = ({
  imageAlt,
  className,
}: Pick<ComponentProps<typeof Modal.BannerImage>, 'imageAlt' | 'className'>) => (
  <Modal.BannerImage image={image} imageWebp={imageWebp} imageAlt={imageAlt} className={className} fullWidth />
);
